import { Schema, arrayOf } from 'normalizr';

import { seasonSchema } from 'state/seasons/schema/seasonsSchema';

export const showSchema = new Schema('show', { idAttribute: 'id' });

showSchema.define({
  seasons: arrayOf(seasonSchema),
});
